// SPDX-License-Identifier: Apache-2.0
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.displayTypes = void 0;
exports.displayTypes = [
    "string",
    "number",
    "boost_percentage",
    "boost_number",
    "date",
];
//# sourceMappingURL=metadata.js.map